import api from './api';
import { handleError } from '../utils/errorHandler';
import {
  Tributacao,
  Condominio,
  Corretora,
  Distribuicao,
  Captacao,
  Status,
  Administrador,
  FundosGerenciadosData,
  FundoSucessao,
} from '../types/fundosGerenciados';

// Fetch all FundosGerenciados
export const getFundosGerenciados = async (): Promise<FundosGerenciadosData[]> => {
  try {
    const response = await api.get<{ results: FundosGerenciadosData[] }>('fundos/fundos_gerenciados/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar fundos gerenciados');
    throw error;
  }
};

// Fetch Tributacao
export const getTributacoes = async (): Promise<Tributacao[]> => {
  try {
    const response = await api.get<{results: Tributacao[]}>('/core/tributacoes/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar tributações');
    throw error;
  }
};

// Fetch Condominio
export const getCondominios = async (): Promise<Condominio[]> => {
  try {
    const response = await api.get<{results: Condominio[]}>('/core/condominios/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar condomínios');
    throw error;
  }
};

// Fetch Corretora
export const getCorretoras = async (): Promise<Corretora[]> => {
  try {
    const response = await api.get<{results: Corretora[]}>('/core/corretoras/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar corretoras');
    throw error;
  }
};

// Fetch Distribuicao
export const getDistribuicoes = async (): Promise<Distribuicao[]> => {
  try {
    const response = await api.get<{results: Distribuicao[]}>('/core/distribuicoes/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar distribuições');
    throw error;
  }
};

// Fetch Captacao
export const getCaptacoes = async (): Promise<Captacao[]> => {
  try {
    const response = await api.get<{results: Captacao[]}>('/core/captacoes/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar captações');
    throw error;
  }
};

// Fetch Administrador
export const getAdministradores = async (): Promise<Administrador[]> => {
  try {
    const response = await api.get<{ results: Administrador[] }>('/core/administradores/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar administradores');
    throw error;
  }
};

// Fetch Status
export const getStatusList = async (): Promise<Status[]> => {
  try {
    const response = await api.get<{ results: Status[] }>('/core/status/');
    return response.data.results;
  } catch (error) {
    handleError(error, 'ao buscar lista de status');
    throw error;
  }
};

// Update Fundo Gerenciado
export const editarFundo = async (fundo: FundosGerenciadosData): Promise<FundosGerenciadosData> => {
  try {
    const response = await api.put<FundosGerenciadosData>(`fundos/fundos_gerenciados/${fundo.id}/`, fundo);
    return response.data;
  } catch (error) {
    handleError(error, 'ao atualizar fundo gerenciado');
    throw error;
  }
};

export const createFundoGerenciado = async (fundoData: FundosGerenciadosData): Promise<FundosGerenciadosData> => {
  try {
    const response = await api.post<FundosGerenciadosData>('fundos/fundos-gerenciados/create/', fundoData);
    return response.data;
  } catch (error) {
    handleError(error, 'ao criar fundo gerenciado');
    throw error;
  }
};

export const deleteFundoGerenciado = async (id: number) => {
  try {
    const response = await api.delete(`/fundos/fundos-gerenciados/${id}/delete/`);
    return response.data;
  } catch (error) {
    handleError(error, 'ao deletar fundo gerenciado');
    throw error;
  }
};

export const getFundoSucessao = async (fundoId: number): Promise<FundoSucessao | null> => {
  try {
    const response = await api.get<FundoSucessao>(`fundos/fundos-gerenciados/${fundoId}/sucessao/`);
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 404) return null;
    handleError(err, 'ao buscar sucessão do fundo');
    throw err;
  }
};

export const getFundoSucessaoComoOrigem = async (fundoId: number): Promise<FundoSucessao | null> => {
  try {
    const response = await api.get<FundoSucessao>(`fundos/fundos-gerenciados/${fundoId}/sucessao-como-origem/`);
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 404) return null;
    handleError(err, 'ao buscar sucessão como origem');
    throw err;
  }
};

export const deleteFundoSucessaoComoOrigem = async (fundoOrigemId: number): Promise<void> => {
  try {
    await api.delete(`fundos/fundos-gerenciados/${fundoOrigemId}/sucessao-como-origem/`);
  } catch (error) {
    handleError(error, 'ao remover registro de transferência');
    throw error;
  }
};

export const postFundoSucessao = async (
  fundoDestinoId: number,
  fundoOrigemId: number,
  dataTransferencia: string,
  observacoes?: string,
): Promise<FundoSucessao> => {
  try {
    const response = await api.post<FundoSucessao>(
      `fundos/fundos-gerenciados/${fundoDestinoId}/sucessao/`,
      { fundo_origem: fundoOrigemId, data_transferencia: dataTransferencia, observacoes },
    );
    return response.data;
  } catch (error) {
    handleError(error, 'ao registrar transferência de carteira');
    throw error;
  }
};
